module.exports = __webpack_public_path__ + "static/media/4ODA17.63ea51b3.jpg";